/*!

=========================================================
* Paper Kit React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React, {useState, useEffect} from "react";

// reactstrap components
import { Row, Col, Container } from "reactstrap";
import { useRecoilValue } from "recoil";
import { websiteDataState } from "helpers/recoil";

import ReactMarkdown from "react-markdown"

// core components
import banner from "../../assets/img/frontpage.jpg"

function IndexHeader() {

  const [isMobile, setIsMobile] = useState(false)

  //choose the screen size
  const handleResize = () => {
    if (window.innerWidth < 992) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }
  const websiteData = useRecoilValue(websiteDataState)

  // create an event listener
  useEffect(() => {
    window.addEventListener("resize", handleResize)
})

  return (
    <>
      <Container>
        <Row style={{ minHeight: "500px", margin: "120px auto 60px", textAlign: isMobile ? "center" : "left", alignItems: "center"}}>
          <Col md="12" lg="7" style={{ verticalAlign: "middle" }} className="animate-fade-in">
            <h1 style={{ fontSize: "48px", fontWeight: "800", letterSpacing: "-1px", marginBottom: "24px", lineHeight: "1.2" }}>
              NOTEBAERT <span style={{ color: "#69be50", margin: "0px 8px" }}>|</span> STANDAERT<br />
              <span style={{ 
                background: "linear-gradient(135deg, #69be50 0%, #5aa542 100%)", 
                color: "#FFFFFF", 
                padding: "8px 20px", 
                marginTop: "16px", 
                fontWeight: "700",
                fontSize: "22px",
                borderRadius: "8px",
                display: "inline-block",
                boxShadow: "0 4px 15px rgba(105, 190, 80, 0.3)"
              }}>GROEPSPRAKTIJK KINESITHERAPIE</span>
            </h1>
            <p style={{ fontSize: "20px", fontWeight: "400", color: "#4a5568", marginTop: "32px", lineHeight: "1.6", marginBottom: "24px" }}>
              {websiteData?.snippetsDictionary?.['subtitle-line1']?.text || ""}<br />
              {websiteData?.snippetsDictionary?.['subtitle-line2']?.text || ""}
            </p>
            <p style={{ fontSize: "16px", marginTop: "24px", color: "#2d3748", fontWeight: "400", lineHeight: "1.6" }}>
              {websiteData?.snippetsDictionary?.['global-address']?.text || ""}<br />
              <span style={{ display: "inline-flex", gap: "12px", marginTop: "12px", flexWrap: "wrap" }}>
                {(websiteData?.snippetsDictionary?.['global-phoneNumber']?.text || "").split("-").map((phone, index) => {
                  const cleanPhone = phone.trim();
                  const telLink = cleanPhone.replace(/[^\d]/g, "");
                  return (
                    <a key={index} href={`tel:${telLink}`} style={{ 
                      background: "linear-gradient(135deg, #00adee 0%, #0096cc 100%)", 
                      color: "#FFFFFF", 
                      padding: "8px 16px", 
                      fontWeight: "600",
                      fontSize: "16px",
                      borderRadius: "6px",
                      display: "inline-block",
                      boxShadow: "0 4px 15px rgba(0, 173, 238, 0.3)",
                      textDecoration: "none",
                      transition: "all 0.3s ease"
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-2px)"}
                    onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}
                    >{cleanPhone}</a>
                  );
                })}
              </span>
            </p>
            <br />
            <div style={{ fontSize: "16px", lineHeight: "1.7", color: "#4a5568" }}>
              <ReactMarkdown>
                {websiteData?.snippetsDictionary?.['global-subparagraph']?.markup.markdown}
              </ReactMarkdown>
            </div>
          </Col>
          <Col md="12" lg="5" className="animate-fade-in">
            <img src={banner} className="img-responsive fit-image" style={{ border: "none" }} />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default IndexHeader;
